import React from 'react';
import { Check } from 'lucide-react';
import { ROOT_CONTAINER } from '@repo/lib';
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@dashboard/components/ui/dropdown-menu';
import { useFormLayout } from '../FormLayoutContext';

export default function MoveToMenu({ itemKey, currentContainerId, disabled }) {
  const { groups, moveItem, layout } = useFormLayout();
  const nowhereElse = groups.length === 0 && currentContainerId === ROOT_CONTAINER;

  const moveTo = containerId => {
    if (containerId === currentContainerId) return;
    const index =
      containerId === ROOT_CONTAINER
        ? layout.length
        : (layout.find(item => item.type === 'group' && item.id === containerId)?.items.length ??
          0);
    moveItem(itemKey, { containerId, index });
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger disabled={disabled || nowhereElse}>Move to</DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="min-w-48">
        {groups.map(group => (
          <DropdownMenuItem key={group.id} onSelect={() => moveTo(group.id)}>
            <span className="truncate">{group.name}</span>
            {currentContainerId === group.id && <Check className="ml-auto size-4" />}
          </DropdownMenuItem>
        ))}
        {groups.length > 0 && <DropdownMenuSeparator />}
        <DropdownMenuItem onSelect={() => moveTo(ROOT_CONTAINER)}>
          Outside a group
          {currentContainerId === ROOT_CONTAINER && <Check className="ml-auto size-4" />}
        </DropdownMenuItem>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
